<template>
  <v-dialog :value="value" persistent max-width="720px" @keydown.esc="close">
    <v-card style="padding: 0px">
      <v-card-title>
        New Route
        <v-spacer></v-spacer>
        <v-btn icon :disabled="saving" @click="close">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="pa-4">
        <elwrapper label="Start" midtext>
          <autocomplete-string-free-text :items="cities" :value="city_start" @input="onCityStartChanged" />
        </elwrapper>
        <elwrapper label="End" midtext>
          <autocomplete-string-free-text :items="cities" :value="city_end" @input="onCityEndChanged" />
        </elwrapper>
        <elwrapper label="Label" midtext>
          <f-text v-model="label" />
        </elwrapper>
        <elwrapper label="Distance (km)" midtext>
          <f-number v-model="distance" />
        </elwrapper>
        <elwrapper label="Travel time" midtext>
          <f-text v-model="travel_time" />
        </elwrapper>
        <RouteViasEditor v-model="vias" :cities="cities" />
        <elwrapper label="Description" midtext>
          <f-textarea v-model="description" rows="10" />
        </elwrapper>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <g-button label="Cancel" :disabled="saving" @onclick="close" />
        <v-spacer></v-spacer>
        <g-button label="Create" type="primary" :disabled="!canCreate || saving" @onclick="create" />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import RouteViasEditor from "./RouteViasEditor";
import { normalizeRouteVias, defaultRouteLabel, normalizeRouteCity } from "../utils";

export default {
  components: {
    RouteViasEditor,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    cityStart: {
      type: String,
      default: "",
    },
    cityEnd: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      cities: [],
      city_start: "",
      city_end: "",
      label: "",
      distance: null,
      travel_time: "",
      vias: [],
      description: "",
      saving: false,
    };
  },
  computed: {
    canCreate() {
      return !!(this.city_start && this.city_end);
    },
  },
  methods: {
    syncLabelFromCities(previousStart, previousEnd, nextStart, nextEnd) {
      const currentLabel = String(this.label || "").trim();
      const previousDefault = defaultRouteLabel(previousStart, previousEnd);
      if (!currentLabel || currentLabel === previousDefault) {
        this.label = defaultRouteLabel(nextStart, nextEnd);
      }
    },
    onCityStartChanged(value) {
      const next = normalizeRouteCity(value);
      const previousStart = normalizeRouteCity(this.city_start);
      const previousEnd = normalizeRouteCity(this.city_end);
      if (previousStart === next) return;
      this.city_start = next;
      this.syncLabelFromCities(previousStart, previousEnd, next, previousEnd);
    },
    onCityEndChanged(value) {
      const next = normalizeRouteCity(value);
      const previousStart = normalizeRouteCity(this.city_start);
      const previousEnd = normalizeRouteCity(this.city_end);
      if (previousEnd === next) return;
      this.city_end = next;
      this.syncLabelFromCities(previousStart, previousEnd, previousStart, next);
    },
    close() {
      if (this.saving) return;
      this.$emit("input", false);
    },
    resetForm() {
      this.city_start = normalizeRouteCity(this.cityStart);
      this.city_end = normalizeRouteCity(this.cityEnd);
      this.label = defaultRouteLabel(this.city_start, this.city_end);
      this.distance = null;
      this.travel_time = "";
      this.vias = [];
      this.description = "";
      this.saving = false;
    },
    create() {
      if (!this.canCreate || this.saving) return;
      this.saving = true;
      const city_start = normalizeRouteCity(this.city_start);
      const city_end = normalizeRouteCity(this.city_end);
      const vias = normalizeRouteVias(this.vias);
      const label = String(this.label || "").trim() || defaultRouteLabel(city_start, city_end);
      return this.$store
        .dispatch("RouteStore/addRoute", {
          city_start,
          city_end,
          label,
          distance: this.distance,
          travel_time: this.travel_time,
          vias,
          description: this.description,
        })
        .then((id) => {
          this.$root.$success("Created Route: " + label);
          const created = {
            id,
            city_start,
            city_end,
            label,
            distance: this.distance,
            travel_time: this.travel_time,
            vias,
            description: this.description,
          };
          this.$emit("created", created);
          this.$emit("input", false);
        })
        .catch((err) => this.$root.$error(err))
        .finally(() => {
          this.saving = false;
        });
    },
    _queryCities() {
      return this.$store
        .dispatch("DatabaseStore/getCityList")
        .then((cities) => {
          this.cities = cities;
        })
        .catch((err) => this.$root.$error(err));
    },
  },
  watch: {
    value(isOpen) {
      if (isOpen) {
        this.resetForm();
        this._queryCities();
      }
    },
  },
};
</script>
